[
  {
    "id": 1,
    "name": "Random Color Sambas",
    "brand": "Adidas",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "ipfs_hash_png": "QmUYbsuJQeU4qaKBBuraeXwPZuALgXEY5fA6YVwxaYe2UL"
  },
  {
    "id": 2,
    "name": "Green Sambas",
    "brand": "Adidas",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "ipfs_hash_png": "QmVWDuHvw3QBfFZfFcvRmxYApnazbM3Qgy33M8qXqW5UVw"
  },
  {
    "id": 3,
    "name": "Doodles x Ice Cream Skate Deck",
    "brand": "Ice Cream",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "ipfs_hash_png": "QmPY6FkneeFHqdEv2xgNS2XYmXBj32Rt7jF2dqTyN5gscT"
  },
  {
    "id": 4,
    "name": "Green Hoodie",
    "brand": "Humanrace",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "ipfs_hash_png": "QmRZywkM3zCfj4JYJifbnT7cQfih5kTrU4zrUcQG3aBPnj"
  },
  {
    "id": 5,
    "name": "Skincare Set",
    "brand": "Humanrace",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "ipfs_hash_png": "QmbTLptAYWkdsWeeMqrFUmQfuAJsxZP1YvrGAuTmYZV1xm"
  }
]
